export default __webpack_public_path__ + "static/media/the-moon@2x.dc25a21b.png";